
// 소유자
export const OWNER = 4;
// 관리자
export const MANAGER = 3;
// 편집자
export const EDITOR = 2;
// 필자
export const WRITER = 1;
// 방문자
export const GUEST = 0;


// 소유자
export const NAME_OWNER = 'owner';
// 관리자
export const NAME_MANAGER = 'manager';
// 편집자
export const NAME_EDITOR = 'editor';
// 필자
export const NAME_WRITER = 'writer';
// 방문자
export const NAME_GUEST = 'guest';

export const canAccess = (currentRole, requireRole) => (currentRole >= requireRole);

export const convertStringToRoleType = (str) => {
    switch(str.toUpperCase()){
        case "OWNER" :
            return OWNER;
        case "MANAGER" :
            return MANAGER;
        case "EDITOR" :
            return EDITOR;
        case "WRITER" :
            return WRITER;
        case "GUEST" :
        default :
            return GUEST;
    }

};

export const convertTypeToString = (typeInt) => {
    switch(typeInt){
        case OWNER :
            return "OWNER";
        case MANAGER :
            return "MANAGER";
        case EDITOR :
            return "EDITOR";
        case WRITER :
            return "WRITER";
        case GUEST:
            return "GUEST";
    }
};

export const getRoleLabel = (str) => {
    switch(str.toUpperCase()){
        case "OWNER" :
            return "소유자";
        case "MANAGER" :
            return "관리자";
        case "EDITOR" :
            return "편집자";
        case "WRITER" :
            return "필자";
        case "GUEST" :
        default :
            return "방문자";
    }
};
